var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_48",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m51.835,10.271h-5.353c-.552,0-1,.448-1,1v13.025c0,2.944-1.898,5.552-4.7,6.457l-.171.055c-3.829,1.237-6.424,4.802-6.424,8.826v46.095c0,2.209,1.791,4,4,4h13.647-3.671,13.647c2.209,0,4-1.791,4-4v-46.096c0-4.023-2.594-7.588-6.423-8.825l-.172-.055c-2.801-.905-4.7-3.513-4.7-6.457v-13.025c0-.552-.448-1-1-1h-5.353",
        },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "45.724", y1: "15.447", x2: "54.518", y2: "15.447" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }